
enum SpousalIncomeType {
    salary
}

export {
    SpousalIncomeType
}



// WEBPACK FOOTER //
// ./src/app/calcs/pensions/spousal/interfaces/index.ts